import { Component, OnInit, OnDestroy } from "@angular/core";
import { ExperiencesService } from "@services/experience/experiences.service";
import { ErrorEmitterService } from "@services/emitters/error-emitter.service";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";
@Component({
  selector: "app-creation-path",
  templateUrl: "./creation-path.component.html",
  styleUrls: ["./creation-path.component.scss"],
})
export class CreationPathComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public loader: boolean = false;
  constructor(
    private experienceSvc: ExperiencesService,
    private errorEmitter: ErrorEmitterService,
    private router: Router
  ) {}

  ngOnInit() {}

  public createExperience() {
    this.loader = true;
    this.experienceSvc
      .createExperience()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.router.navigate(["create-experience", x.result.id]);
          this.loader = true;
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
